var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"btn btn--primary btn--sm",attrs:{"href":"https://browser-update.org/update.html","target":"_blank","rel":"noopener noreferrer"}},[_vm._v("Update my browser ")])}
var staticRenderFns = []

export { render, staticRenderFns }